import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
})
export class StepperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
